import { render, staticRenderFns } from "./DefaultCKEditor.vue?vue&type=template&id=48e52de6&scoped=true"
import script from "./DefaultCKEditor.vue?vue&type=script&lang=js"
export * from "./DefaultCKEditor.vue?vue&type=script&lang=js"
import style0 from "./DefaultCKEditor.vue?vue&type=style&index=0&id=48e52de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e52de6",
  null
  
)

export default component.exports